import React, { useEffect, useState } from 'react';
import { States } from '@/helpers/common/states';
import api, { AxiosError } from '@/services/api';
import { EventMachineSaleProductReport } from '@/model/EventMachineSaleProductReport';
import { toast } from 'react-toastify';
import { ReportControllerProps } from '../../types';
import { SaleProductMachineContent } from './ui';

interface StateProps {
  reportController: ReportControllerProps;
  setState: (state: States) => void;
}

export const SaleProductMachine: React.FC<StateProps> = ({
  reportController,
  setState,
}): JSX.Element => {
  const { eventId, singleEvent } = reportController;
  const [machines, setMachines] = useState<EventMachineSaleProductReport[]>([]);

  const handleGetSaleProducts = async (): Promise<void> => {
    try {
      setState(States.loading);
      const { data } = await api.get<EventMachineSaleProductReport[]>(
        `event/report/${eventId}/sale-product/machine?singleEvent=${singleEvent}`,
      );
      if (data) {
        setMachines(data);
      }
    } catch (error) {
      const err = error as AxiosError;
      toast.error(err.message);
    } finally {
      setState(States.default);
    }
  };

  useEffect(() => {
    handleGetSaleProducts();
  }, []);
  return <SaleProductMachineContent machines={machines} />;
};
